import React, { Fragment, useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { motion } from 'framer-motion';
import ReactTooltip from 'react-tooltip';

import { storeSelectedProgrammeDetails, storeReportType } from '../../actions/reports';

import reportTypes from './reportTypes';
import SupportersTable from './SupportersTable';
import ReportSelect from './ReportSelect';
import ReportDetails from './ReportDetails';
import fadeInUp from '../../helpers/Animations';

import '../../styles/components/_reports.scss';
import { useParams } from 'react-router';

const Reports = ({ reports, match, setProgramme, history, setReportType }) => {
  const params = useParams();
  useEffect(() => {
    if (params?.program_id && reports.length > 0) {
      // Get program ID from URL and set as selected program...
      const program = reports.find((report) => String(report.code) === String(params.program_id));
      if (program) {
        setProgramme(program);
        if (params.report && reportTypes[params.report]) {
          // setReportType(reportTypes[params.report]);
        }
        // history.replace('/reports');
      }
    }
  }, [history, match, params, reports, setProgramme, setReportType]);

  return (
    <Fragment>
      <MetaTags>
        <title>AFES - Staff Reports</title>
      </MetaTags>
      <div className="reports">
        <h1 className="white">Staff Reports</h1>
        <motion.div animate={fadeInUp.animate} transition={fadeInUp.transition} className="reports__wrap">
          {reports?.length > 0 && (
            <Fragment>
              <ReportSelect />
              <ReportDetails />
              <SupportersTable />
            </Fragment>
          )}
        </motion.div>
      </div>
      <ReactTooltip type="info" />
    </Fragment>
  );
};

Reports.defaultProps = {
  reports: [],
  match: {}
};

Reports.propTypes = {
  reports: PropTypes.arrayOf(PropTypes.object),
  match: PropTypes.shape({
    isExact: PropTypes.bool,
    params: PropTypes.shape({ program_id: PropTypes.string, report: PropTypes.string }),
    path: PropTypes.string,
    url: PropTypes.string,
  }),
  setProgramme: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
  setReportType: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  setProgramme: (programmeID) => dispatch(storeSelectedProgrammeDetails(programmeID)),
  setReportType: (reportType) => dispatch(storeReportType(reportType)),
});

const mapStateToProps = (state) => ({
  reports: state.session.userdata.reports,
});

export default connect(mapStateToProps, mapDispatchToProps)(Reports);
